import React from "react";
import { Button, BUTTON_SIZE, BUTTON_THEME } from "App/core/Button";
import { ReactComponent as CloseIcon } from "App/common/icons-v2/close.svg";
import { ReactComponent as SendIcon } from "App/common/icons-v2/arrow-up.svg";

interface CommentInputActionsProps {
  onClear: () => void;
  focusedCardId: string | null;
  onSave: () => void;
}

export const CommentInputActions = ({
  onClear,
  focusedCardId,
  onSave,
}: CommentInputActionsProps) => {
  return (
    <div
      className="highnote-comment-input-actions"
      data-is-disabled={!!focusedCardId}
      role="toolbar"
      aria-label="Comment input actions"
    >
      <Button
        disabled={!!focusedCardId}
        className="close-icon"
        size={BUTTON_SIZE.MEDIUM}
        onClick={onClear}
        theme={BUTTON_THEME.PRIMARY}
        aria-label="Clear comment"
      >
        <CloseIcon />
      </Button>
      <Button
        disabled={!!focusedCardId}
        className="send-icon"
        size={BUTTON_SIZE.MEDIUM}
        theme={BUTTON_THEME.CTA}
        onClick={onSave}
        aria-label="Add comment"
      >
        <SendIcon />
      </Button>
    </div>
  );
};

CommentInputActions.displayName = "CommentInputActions";
